import {
  LOGIN_URL,
  RESET_PASSWORD_URL,
  HOME_URL,
  LOGIN_URL_NAME,
  RESET_PASSWORD_URL_NAME,
  VEHICLES_URL_NAME,
  VEHICLES_URL,
  EMPLOYEES_URL,
  EMPLOYEES_URL_NAME,
  CUSTOMERS_URL,
  CUSTOMERS_URL_NAME,
  CUSTOMERS_ADD_URL_NAME,
  TRAILERS_URL,
  TRAILERS_URL_NAME,
  FIELDS_URL,
  FIELDS_URL_NAME,
  FARMS_URL,
  FARMS_URL_NAME,
  SERVICES_URL,
  SERVICES_URL_NAME,
  DELIVERY_SITES_URL,
  DELIVERY_SITES_URL_NAME,
  COLLECTION_SITES_URL,
  COLLECTION_SITES_URL_NAME,
  PRODUCTS_URL,
  PRODUCTS_URL_NAME,
  SILOS_URL,
  SILOS_URL_NAME,
  TIME_SHEETS_URL,
  TIME_SHEETS_URL_NAME,
  SPREADING_JOBS_URL,
  SPREADING_JOBS_URL_NAME,
  HAULAGE_JOBS_URL,
  HAULAGE_JOBS_URL_NAME,
  HAULAGE_JOBS_ADD_URL_NAME,
  HAULAGE_JOBS_DETAILS_URL_NAME,
  SPREADING_JOBS_ADD_URL_NAME,
  DIGESTATE_JOBS_URL,
  DIGESTATE_JOBS_URL_NAME,
  DIGESTATE_JOBS_ADD_URL_NAME,
  DIGESTATE_JOBS_DETAILS_URL_NAME,
  TRANSPORT_JOBS_URL,
  TRANSPORT_JOBS_URL_NAME,
  HAULAGE_JOBS_LIST_URL_NAME,
  DIGESTATE_JOBS_LIST_URL_NAME,
  EMPLOYEES_ADD_URL_NAME,
  TRAILERS_ADD_URL_NAME,
  VEHICLES_ADD_URL_NAME,
  FIELDS_ADD_URL_NAME,
  HAULAGE_JOBS_SCHEDULE_JOB_URL_NAME,
  HAULAGE_JOBS_SCHEDULE_JOB_URL,
  DIGESTATE_JOBS_SCHEDULE_JOB_URL,
  DIGESTATE_JOBS_SCHEDULE_JOB_URL_NAME,
  COLLECTION_SITES_ADD_URL_NAME,
  DELIVERY_SITES_ADD_URL_NAME,
  FARMS_ADD_URL_NAME,
  PRODUCTS_ADD_URL_NAME,
  SERVICES_ADD_URL_NAME,
  SILOS_ADD_URL_NAME,
  TIME_SHEETS_ADD_URL_NAME,
  SPREADING_JOBS_DETAILS_URL_NAME,
  SPREADING_JOBS_LIST_URL_NAME,
  TIME_SHEETS_LIST_URL_NAME,
  SILOS_LIST_URL_NAME,
  PRODUCTS_LIST_URL_NAME,
  COLLECTION_SITES_LIST_URL_NAME,
  DELIVERY_SITES_LIST_URL_NAME,
  SERVICES_LIST_URL_NAME,
  FARMS_LIST_URL_NAME,
  FIELDS_LIST_URL_NAME,
  VEHICLES_LIST_URL_NAME,
  TRAILERS_LIST_URL_NAME,
  CUSTOMERS_LIST_URL_NAME,
  EMPLOYEES_LIST_URL_NAME,
  HOME_URL_NAME,
  ERRORS_URL_NAME,
  ERRORS_URL,
  ADD_URL,
  HAULAGE_JOBS_EDIT_JOB_URL,
  HAULAGE_JOBS_EDIT_JOB_URL_NAME,
  DIGESTATE_JOBS_EDIT_JOB_URL,
  DIGESTATE_JOBS_EDIT_JOB_URL_NAME,
  SPREADING_JOBS_EDIT_JOB_URL_NAME,
  SPREADING_JOBS_EDIT_JOB_URL,
  SILOS_EDIT_URL,
  SILOS_EDIT_URL_NAME,
  TIMESHEET_EDIT_URL_NAME,
  TIMESHEET_EDIT_URL,
  FIELDS_EDIT_URL_NAME,
  FIELDS_EDIT_URL,
  PRODUCTS_EDIT_URL,
  PRODUCTS_EDIT_URL_NAME,
  COLLECTION_SITES_EDIT_URL,
  COLLECTION_SITES_EDIT_URL_NAME,
  DELIVERY_SITES_EDIT_URL,
  DELIVERY_SITES_EDIT_URL_NAME,
  SERVICES_EDIT_URL,
  SERVICES_EDIT_URL_NAME,
  FARMS_EDIT_URL_NAME,
  FARMS_EDIT_URL,
  EMPLOYEES_EDIT_URL,
  EMPLOYEES_EDIT_URL_NAME,
  VEHICLES_EDIT_URL,
  VEHICLES_EDIT_URL_NAME,
  TRAILERS_EDIT_URL,
  TRAILERS_EDIT_URL_NAME,
  CUSTOMERS_EDIT_URL,
  CUSTOMERS_EDIT_URL_NAME,
  HISTORY_URL,
  SILOS_HISTORY_URL_NAME,
  INSPECTIONS_URL,
  SILOS_INSPECTIONS_URL_NAME,
  VEHICLES_INSPECTIONS_LIST_URL_NAME,
  SET_PASSWORD_URL_NAME,
  SET_PASSWORD_URL,
  FUEL_ENTRIES_URL,
  FUEL_ENTRIES_URL_NAME,
  WASTE_DELIVERY_SITES_URL,
  WASTE_DELIVERY_SITES_URL_NAME,
  WASTE_DELIVERY_SITES_LIST_URL_NAME,
  WASTE_DELIVERY_SITES_ADD_URL_NAME,
  WASTE_DELIVERY_SITES_EDIT_URL,
  WASTE_DELIVERY_SITES_EDIT_URL_NAME,
  DEF_ENTRIES_URL,
  DEF_ENTRIES_URL_NAME
} from '@/utils/constants'

// import { LoginView } from '@/views'

import type { RouteRecordRaw } from 'vue-router'

async function isEnvDevOrLocal(to: any, from: any, next: any) {
  if (process.env.NODE_ENV === 'development' || window.location.origin.includes('localhost')) {
    next()
  } else {
    next(false)
  }
}

export const navigationRoutes: Array<RouteRecordRaw> = [
  {
    path: TRANSPORT_JOBS_URL,
    name: TRANSPORT_JOBS_URL_NAME,
    redirect: `${TRANSPORT_JOBS_URL}/${HAULAGE_JOBS_URL}`,
    meta: { displayName: TRANSPORT_JOBS_URL_NAME },
    children: [
      {
        path: HAULAGE_JOBS_URL,
        name: HAULAGE_JOBS_URL_NAME,
        component: () => import('@/views/haulageJobs/HaulageJobsView.vue'),
        children: [
          { path: '', name: HAULAGE_JOBS_LIST_URL_NAME, component: () => import('@/views/haulageJobs/HaulageJobsList.vue') },
          { path: ADD_URL, name: HAULAGE_JOBS_ADD_URL_NAME, component: () => import('@/views/haulageJobs/HaulageJobsAddView.vue') },
          {
            path: ':id',
            component: () => import('@/views/haulageJobs/HaulageJobsDetailsView.vue'),
            props: true,
            children: [
              {
                path: '',
                name: HAULAGE_JOBS_DETAILS_URL_NAME,
                component: () => import('@/views/haulageJobs/HaulageJobDetails.vue')
              },
              {
                path: HAULAGE_JOBS_SCHEDULE_JOB_URL,
                name: HAULAGE_JOBS_SCHEDULE_JOB_URL_NAME,
                component: () => import('@/views/haulageJobs/HaulageJobsScheduledView.vue')
              },
              {
                path: HAULAGE_JOBS_EDIT_JOB_URL,
                name: HAULAGE_JOBS_EDIT_JOB_URL_NAME,
                component: () => import('@/views/haulageJobs/HaulageJobEditDetails.vue')
              }
            ]
          }
        ]
      },
      {
        path: DIGESTATE_JOBS_URL,
        name: DIGESTATE_JOBS_URL_NAME,
        component: () => import('@/views/digestateJobs/DigestateJobsView.vue'),
        children: [
          { path: '', name: DIGESTATE_JOBS_LIST_URL_NAME, component: () => import('@/views/digestateJobs/DigestateJobsList.vue') },
          { path: ADD_URL, name: DIGESTATE_JOBS_ADD_URL_NAME, component: () => import('@/views/digestateJobs/DigestateJobsAddView.vue') },
          {
            path: ':id',
            component: () => import('@/views/digestateJobs/DigestateJobsDetailsView.vue'),
            props: true,
            children: [
              {
                path: '',
                name: DIGESTATE_JOBS_DETAILS_URL_NAME,
                component: () => import('@/views/digestateJobs/DigestateJobDetails.vue')
              },
              {
                path: DIGESTATE_JOBS_SCHEDULE_JOB_URL,
                name: DIGESTATE_JOBS_SCHEDULE_JOB_URL_NAME,
                component: () => import('@/views/digestateJobs/DigestateJobsScheduledView.vue')
              },
              {
                path: DIGESTATE_JOBS_EDIT_JOB_URL,
                name: DIGESTATE_JOBS_EDIT_JOB_URL_NAME,
                component: () => import('@/views/digestateJobs/DigestateJobEditDetails.vue')
              }
            ]
          }
        ]
      }
    ] as RouteRecordRaw[]
  },
  {
    path: SPREADING_JOBS_URL,
    name: SPREADING_JOBS_URL_NAME,
    meta: { displayName: SPREADING_JOBS_URL_NAME },
    children: [
      { path: '', name: SPREADING_JOBS_LIST_URL_NAME, component: () => import('@/views/spreadingJobs/SpreadingJobsView.vue') },
      { path: ADD_URL, name: SPREADING_JOBS_ADD_URL_NAME, component: () => import('@/views/spreadingJobs/SpreadingJobsAddView.vue') },
      {
        path: ':id',
        component: () => import('@/views/spreadingJobs/SpreadingJobsDetailsView.vue'),
        props: true,
        children: [
          {
            path: '',
            name: SPREADING_JOBS_DETAILS_URL_NAME,
            component: () => import('@/views/spreadingJobs/SpreadingJobDetails.vue')
          },
          {
            path: SPREADING_JOBS_EDIT_JOB_URL,
            name: SPREADING_JOBS_EDIT_JOB_URL_NAME,
            component: () => import('@/views/spreadingJobs/SpreadingJobsEditView.vue')
          }
        ]
      }
    ]
  },
  {
    path: TIME_SHEETS_URL,
    name: TIME_SHEETS_URL_NAME,
    meta: { displayName: TIME_SHEETS_URL_NAME },
    children: [
      { path: '', name: TIME_SHEETS_LIST_URL_NAME, component: () => import('@/views/timesheets/TimeSheetsView.vue') },
      { path: ADD_URL, name: TIME_SHEETS_ADD_URL_NAME, component: () => import('@/views/timesheets/TimeSheetsAddView.vue') },
      {
        path: ':id',
        props: true,
        children: [
          {
            path: TIMESHEET_EDIT_URL,
            name: TIMESHEET_EDIT_URL_NAME,
            component: () => import('@/views/timesheets/TimeSheetsEditView.vue')
          }
        ]
      }
    ]
  },
  {
    path: SILOS_URL,
    name: SILOS_URL_NAME,
    meta: { displayName: SILOS_URL_NAME },
    children: [
      { path: '', name: SILOS_LIST_URL_NAME, component: () => import('@/views/silos/SilosView.vue') },
      { path: ADD_URL, name: SILOS_ADD_URL_NAME, component: () => import('@/views/silos/SilosAddView.vue') },
      {
        path: ':id',
        props: true,
        children: [
          {
            path: SILOS_EDIT_URL,
            name: SILOS_EDIT_URL_NAME,
            component: () => import('@/views/silos/SilosEditView.vue')
          },
          {
            path: HISTORY_URL,
            name: SILOS_HISTORY_URL_NAME,
            component: () => import('@/views/silos/SilosHistoryView.vue')
          },
          {
            path: INSPECTIONS_URL,
            name: SILOS_INSPECTIONS_URL_NAME,
            component: () => import('@/views/silos/SilosInspectionsView.vue')
          }
        ]
      }
    ]
  },
  {
    path: PRODUCTS_URL,
    name: PRODUCTS_URL_NAME,
    meta: { displayName: PRODUCTS_URL_NAME },
    children: [
      { path: '', name: PRODUCTS_LIST_URL_NAME, component: () => import('@/views/products/ProductsView.vue') },
      { path: ADD_URL, name: PRODUCTS_ADD_URL_NAME, component: () => import('@/views/products/ProductsAddView.vue') },
      {
        path: ':id',
        props: true,
        children: [
          {
            path: PRODUCTS_EDIT_URL,
            name: PRODUCTS_EDIT_URL_NAME,
            component: () => import('@/views/products/ProductEditView.vue')
          }
        ]
      }
    ]
  },
  {
    path: COLLECTION_SITES_URL,
    name: COLLECTION_SITES_URL_NAME,
    meta: { displayName: COLLECTION_SITES_URL_NAME },
    children: [
      { path: '', name: COLLECTION_SITES_LIST_URL_NAME, component: () => import('@/views/collectionSites/CollectionSitesView.vue') },
      { path: ADD_URL, name: COLLECTION_SITES_ADD_URL_NAME, component: () => import('@/views/collectionSites/CollectionSitesAddView.vue') },
      {
        path: ':id',
        props: true,
        children: [
          {
            path: COLLECTION_SITES_EDIT_URL,
            name: COLLECTION_SITES_EDIT_URL_NAME,
            component: () => import('@/views/collectionSites/CollectionSiteEditView.vue')
          }
        ]
      }
    ]
  },
  {
    path: WASTE_DELIVERY_SITES_URL,
    name: WASTE_DELIVERY_SITES_URL_NAME,
    meta: { displayName: WASTE_DELIVERY_SITES_URL_NAME },
    children: [
      { path: '', name: WASTE_DELIVERY_SITES_LIST_URL_NAME, component: () => import('@/views/wasteDeliverySite/WasteDeliverySiteView.vue') },
      { path: ADD_URL, name: WASTE_DELIVERY_SITES_ADD_URL_NAME, component: () => import('@/views/wasteDeliverySite/WasteDeliverySiteAddView.vue') },
      {
        path: ':id',
        props: true,
        children: [
          {
            path: WASTE_DELIVERY_SITES_EDIT_URL,
            name: WASTE_DELIVERY_SITES_EDIT_URL_NAME,
            component: () => import('@/views/wasteDeliverySite/WasteDeliverySiteEditView.vue')
          }
        ]
      }
    ]
  },
  {
    path: DELIVERY_SITES_URL,
    name: DELIVERY_SITES_URL_NAME,
    meta: { displayName: DELIVERY_SITES_URL_NAME },
    children: [
      { path: '', name: DELIVERY_SITES_LIST_URL_NAME, component: () => import('@/views/adPlantSites/ADPlantSitesView.vue') },
      { path: ADD_URL, name: DELIVERY_SITES_ADD_URL_NAME, component: () => import('@/views/adPlantSites/ADPlantSiteAddView.vue') },
      {
        path: ':id',
        props: true,
        children: [
          {
            path: DELIVERY_SITES_EDIT_URL,
            name: DELIVERY_SITES_EDIT_URL_NAME,
            component: () => import('@/views/adPlantSites/ADPlantSiteEditView.vue')
          }
        ]
      }
    ]
  },
  {
    path: SERVICES_URL,
    name: SERVICES_URL_NAME,
    meta: { displayName: SERVICES_URL_NAME },
    children: [
      { path: '', name: SERVICES_LIST_URL_NAME, component: () => import('@/views/wasteCollectionServices/WasteCollectionServicesView.vue') },
      { path: ADD_URL, name: SERVICES_ADD_URL_NAME, component: () => import('@/views/wasteCollectionServices/WasteCollectionServiceAddView.vue') },
      {
        path: ':id',
        props: true,
        children: [
          {
            path: SERVICES_EDIT_URL,
            name: SERVICES_EDIT_URL_NAME,
            component: () => import('@/views/wasteCollectionServices/WasteCollectionServiceEditView.vue')
          }
        ]
      }
    ]
  },
  {
    path: FARMS_URL,
    name: FARMS_URL_NAME,
    meta: { displayName: FARMS_URL_NAME },
    children: [
      { path: '', name: FARMS_LIST_URL_NAME, component: () => import('@/views/farms/FarmsView.vue') },
      { path: ADD_URL, name: FARMS_ADD_URL_NAME, component: () => import('@/views/farms/FarmsAddView.vue') },
      {
        path: ':id',
        props: true,
        children: [
          {
            path: FARMS_EDIT_URL,
            name: FARMS_EDIT_URL_NAME,
            component: () => import('@/views/farms/FarmsEditView.vue')
          }
        ]
      }
    ]
  },
  {
    path: FIELDS_URL,
    name: FIELDS_URL_NAME,
    meta: { displayName: FIELDS_URL_NAME },
    children: [
      { path: '', name: FIELDS_LIST_URL_NAME, component: () => import('@/views/fields/FieldsView.vue') },
      { path: ADD_URL, name: FIELDS_ADD_URL_NAME, component: () => import('@/views/fields/FieldsAddView.vue') },
      {
        path: ':id',
        props: true,
        children: [
          {
            path: FIELDS_EDIT_URL,
            name: FIELDS_EDIT_URL_NAME,
            component: () => import('@/views/fields/FieldsEditView.vue')
          }
        ]
      }
    ]
  },
  {
    name: VEHICLES_URL_NAME,
    path: VEHICLES_URL,
    meta: { displayName: VEHICLES_URL_NAME },
    children: [
      { path: '', name: VEHICLES_LIST_URL_NAME, component: () => import('@/views/vehicles/VehiclesView.vue') },
      { path: ADD_URL, name: VEHICLES_ADD_URL_NAME, component: () => import('@/views/vehicles/VehiclesAddView.vue') },
      {
        path: ':id',
        props: true,
        children: [
          {
            path: VEHICLES_EDIT_URL,
            name: VEHICLES_EDIT_URL_NAME,
            component: () => import('@/views/vehicles/VehicleEditView.vue')
          },
          {
            path: INSPECTIONS_URL,
            name: VEHICLES_INSPECTIONS_LIST_URL_NAME,
            component: () => import('@/views/vehicles/VehicleInspectionsView.vue')
          },
          {
            path: FUEL_ENTRIES_URL,
            name: FUEL_ENTRIES_URL_NAME,
            component: () => import('@/views/vehicles/VehicleFuelEntriesView.vue')
          },
          {
            path: DEF_ENTRIES_URL,
            name: DEF_ENTRIES_URL_NAME,
            component: () => import('@/views/vehicles/VehicleDefEntriesView.vue')
          }
        ]
      }
    ]
  },
  {
    path: TRAILERS_URL,
    name: TRAILERS_URL_NAME,
    meta: { displayName: TRAILERS_URL_NAME },
    children: [
      { path: '', name: TRAILERS_LIST_URL_NAME, component: () => import('@/views/trailers/TrailersView.vue') },
      { path: ADD_URL, name: TRAILERS_ADD_URL_NAME, component: () => import('@/views/trailers/TrailersAddView.vue') },
      {
        path: ':id',
        props: true,
        children: [
          {
            path: TRAILERS_EDIT_URL,
            name: TRAILERS_EDIT_URL_NAME,
            component: () => import('@/views/trailers/TrailersEditView.vue')
          }
        ]
      }
    ]
  },
  {
    path: CUSTOMERS_URL,
    name: CUSTOMERS_URL_NAME,
    meta: { displayName: CUSTOMERS_URL_NAME },
    children: [
      { path: '', name: CUSTOMERS_LIST_URL_NAME, component: () => import('@/views/customers/CustomersView.vue') },
      { path: ADD_URL, name: CUSTOMERS_ADD_URL_NAME, component: () => import('@/views/customers/CustomersAddView.vue') },
      {
        path: ':id',
        props: true,
        children: [
          {
            path: CUSTOMERS_EDIT_URL,
            name: CUSTOMERS_EDIT_URL_NAME,
            component: () => import('@/views/customers/CustomersEditView.vue')
          }
        ]
      }
    ]
  },
  {
    path: EMPLOYEES_URL,
    name: EMPLOYEES_URL_NAME,
    meta: { displayName: EMPLOYEES_URL_NAME },
    children: [
      { path: '', name: EMPLOYEES_LIST_URL_NAME, component: () => import('@/views/employees/EmployeesView.vue') },
      { path: ADD_URL, name: EMPLOYEES_ADD_URL_NAME, component: () => import('@/views/employees/EmployeeAddView.vue') },
      {
        path: ':id',
        props: true,
        children: [
          {
            path: EMPLOYEES_EDIT_URL,
            name: EMPLOYEES_EDIT_URL_NAME,
            component: () => import('@/views/employees/EmployeeEditView.vue')
          }
        ]
      }
    ]
  }
]

const routes: Array<RouteRecordRaw> = [
  ...navigationRoutes,
  {
    path: LOGIN_URL,
    name: LOGIN_URL_NAME,
    component: () => import('@/views/LoginView.vue')
  },
  {
    path: RESET_PASSWORD_URL,
    name: RESET_PASSWORD_URL_NAME,
    component: () => import('@/views/ResetPasswordView.vue')
  },
  {
    path: SET_PASSWORD_URL,
    name: SET_PASSWORD_URL_NAME,
    component: () => import('@/views/ResetPasswordView.vue')
  },
  {
    path: ERRORS_URL,
    name: ERRORS_URL_NAME,
    component: () => import('@/views/ErrorsView.vue'),
    beforeEnter: isEnvDevOrLocal
  },
  {
    name: HOME_URL_NAME,
    path: HOME_URL,
    alias: TRANSPORT_JOBS_URL,
    redirect: `${TRANSPORT_JOBS_URL}/${HAULAGE_JOBS_URL}`
  }
]

export default routes
